import React  from 'react';
import '../Other/Other.css';

const Posters = function() {

  const data_pubs = [
    {
      img: "img/posters/gmm.png",
      title: "GraphletMatchMaker: Visual Analytics Approaches to Graph Matching in Cybersecurity Communities",
      authors: "Tovanich, N., Pister, A., Richer, G., Valdivia, P., Fekete, J. D., Prieur, C., & Isenberg, P. ",
      booktitle: "IEEE Visual Analytics Science and Technology, VAST Challenge",
      year: "2020",
      pdf: "https://hal.archives-ouvertes.fr/hal-02986447/file/GraphletMatchMaker.pdf",
      project_page: "https://graphletmatchmaker.github.io/",
      demo: "https://graphletmatchmaker.github.io/AVIZ-Tovanich-MC1/matchmaker/index.html"
    },
    {
      img: "img/posters/paohvis.png",
      title: "Using Dynamic Hypergraphs to Reveal the Evolution of the Business Network of a 17th Century French Woman Merchant",
      authors: "Valdivia, P., Buono, P., Plaisant, C., Dufournaud, N., & Fekete, J. D.",
      booktitle: "Eurovis",
      year: "2018",
      pdf: "https://hal.inria.fr/hal-01855675/document",
    },
    {
      img: "img/posters/paovis_poster.png",
      title: "Hypenet: Visualizing Dynamic Hypergraphs",
      authors: "Valdivia, P., Buono, P., & Fekete, J. D.",
      booktitle: "Eurovis",
      year: "2017",
      pdf: "files/Hypenet_EuroVis17.pdf",
      external: "https://hal.inria.fr/hal-01658087/"
    }, {
      img: "img/posters/DeciSCM_teaser.png",
      title: "DCPAIRS: A Pairs Plot Based Decision Support System.",
      authors: "Dimara, E., Valdivia, P., & Kinkeldey, C.",
      booktitle: "Eurovis",
      year: "2017",
      pdf: "files/Poster-DcPairs-EuroVis17.pdf",
      external: "https://hal.inria.fr/hal-01516470/"
    },
  ];

  const publications = data_pubs.map((pub, i) => {
    return (
        <span key={i}>
          <div className="publication d-flex flex-column flex-sm-row">
            <div className="figure flex-shrink-1 w-auto pb-0 pb-sm-2">
              {pub.img && <img alt={pub.title} src={pub.img}/>}
            </div>
            <div className="ref w-100 w-sm-75 pl-0 pl-sm-3 pt-3 pt-sm-0 flex-shrink-0 flex-grow-1">
              <span className="ptitle"> <a href={pub.pdf}> {pub.title} </a> </span>
              <span className="authors"> {pub.authors} </span>
              <span className="booktitle"> {pub.booktitle}, </span>
              {pub.pages && <span className="pages"> {pub.pages}, </span>}
              <span className="year"> {pub.year}.</span>
              {pub.pdf && <span className="document"> <a href={pub.pdf}> <img alt="pdf" src="img/pdf.png"
                                                                              className="icon"/> </a> </span>}
              {pub.link && <span className="document"> <a href={pub.link}> <img alt="doi" src="img/doi.png"
                                                                                className="icon"/> </a></span>}
              {pub.demo && <span className="document">
                <a title="demo" href={pub.demo}> <img alt="demo" src="img/demo.png" className="icon" />
                </a> </span>}
              {pub.project_page && <span className="document"> <a  title="project page" href={pub.project_page}> <img alt="link" src="img/external.png" className="icon" /> </a> </span>}
              {pub.external &&
              <span className="document"> <a href={pub.external}> <img alt="link" src="img/external.png"
                                                                       className="icon"/> </a> </span>}
              {pub.git &&
              <span className="document"> <a href={pub.git}> <img alt="pdf" src="img/github.png" className="icon"/> </a> </span>}
              {pub.gitlab &&
              <span className="document"> <a href={pub.gitlab}> <img alt="pdf" src="img/gitlab.png" className="icon"/> </a> </span>}
            </div>
          </div>
          <div className="space"></div>
        </span>
    );
  });

  return (
    <div  id="other" className="other">

      <div className="space"></div>
      <h2>
        SHORT PAPERS AND POSTERS
      </h2>
      <div className="space"></div>

      {publications}

      <div className="space-lg"></div>

    </div>

  );
}

export default Posters;



// WEBPACK FOOTER //
// ./src/Publications/Posters.js